
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Les tendances qui se dessinent pour le SEO en 2026",
    description:
      "Découvrez les tendances du SEO pour 2026. Anticipez les évolutions majeures du référencement naturel pour adapter votre stratégie et rester en tête des résultats.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
